import React from 'react'
import { Grid, Typography, Box, Paper } from "@material-ui/core";
import clsx from "clsx";

export default function DashboardCard(props) {
  return (
    <Grid item xs={12} sm>
      <Paper className={clsx("height100 ", props.className)}>
        <Box p={1} >
          <Grid container spacing={1}>
            <Grid item sm>
              <Box pb={1}>
                <Typography>
                  <p className="dashboardVertical">{props.heading}</p>
                </Typography>
              </Box>
              <Grid container spacing={1}>
                <Grid item xs={4}>
                  <Box >
                    <p className="dashboardHeading">{props.parameter.param1}</p>
                  </Box>
                  <p className="dashboardNumber">
                    {props.value.YTD}
                  </p>
                </Grid>

                <Grid item xs={4}>
                  <Box >
                    <p className="dashboardHeading">{props.parameter.param2}</p>
                  </Box>
                  <p className="dashboardNumber">
                    {props.value.MTD}
                  </p>
                </Grid>

                <Grid item xs={4}>
                  <Box >
                    <p className="dashboardHeading">{props.parameter.param3}</p>
                  </Box>
                  <p className="dashboardNumber">
                    {props.value.Today}
                    {/* <CurrencyFormat value={88} displayType={'text'} thousandSeparator={true} thousandSpacing={'2s'} prefix={''} /> */}
                  </p>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Grid>
  );
}